
var LSOK = false, //是否支持localstorage
	COOKIE = {
		get: function (name) {
			var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
			if (arr = document.cookie.match(reg))
				return unescape(decodeURIComponent(arr[2]));
			else
				return null
		},
		set: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
			if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
				return false;
			}
			var sExpires = "";
			if (vEnd) {
				switch (vEnd.constructor) {
					case Number:
						sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
						break;
					case String:
						sExpires = "; expires=" + vEnd;
						break;
					case Date:
						sExpires = "; expires=" + vEnd.toUTCString();
						break;
				}
			}
			document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
			var data = {};
			data[sKey] = sValue
			return {};
		},
		del: function (name) {
			var exp = new Date();
			exp.setTime(0);
			this.set(name, this.get(name), exp, '/');
		}
	},
	$localStorage = null;
try {
	window.localStorage.setItem('lsCheck', 'true');
	window.localStorage.removeItem('lsCheck');
	LSOK = true;
} catch (e) {
	console.error(e);
}
if (LSOK) {
	var $localStorage = {
		get: function (key) {
			return window.localStorage[key] ? JSON.parse(window.localStorage[key]) : null;
		},
		set: function (key, value) {
			window.localStorage.setItem(key, JSON.stringify(value));
			return JSON.parse(window.localStorage[key]);
		},
		del: function (key) {
			window.localStorage.removeItem(key);
			return true;
		}
	}
} else {
	var $localStorage = {
		get: function (key) {
			return JSON.parse(COOKIE.get(key));
		},
		set: function (key, value) {
			var CURRENT_DATE = new Date(); //cookie的时间戳
			CURRENT_DATE.setDate(CURRENT_DATE.getDate() + 30);
			COOKIE.set(key, JSON.stringify(value), CURRENT_DATE, '/');
			return value;
		},
		del: function (key) {
			COOKIE.del(key);
			return true;
		}
	}
}

export default $localStorage;